
// ARRAYS
export const mockSalesByDay = [
  {
    isLoading: true,
    isMessage: false,
    isError: false,
    dia: '2022-09-11T00:00:00.000Z',
    receita: 400,
    quantidadeIngressosVendidos: '4'
  },
]

export const mockSalesByHour = [
  {
    isLoading: true,
    isMessage: false,
    isError: false,
    hora: '00:00',
    receita: 0,
    quantidadeIngressosVendidos: '0'
  },
]

export const mockGoalsGeneral = {
  isLoading: true,
  isMessage: false,
  isError: false,
  meta: 1,
  quantidadeVendas: 100,
  percentualMeta: 100
}

export const mockSalesByProduct = [
  {
    isLoading: true,
    isMessage: false,
    isError: false,
    capacity: 68,
    courtesies: 0,
    id: 108407,
    name: "ÁREA VIP",
    payers: 374,
    public: 374,
    totalRevenue: 15478
  }
]

export const mockSalesLocator = [
  {
    isLoading: true,
    isMessage: false,
    isError: false,
    uf: 'RJ',
    estado: 'Rio de Janeiro',
    quantidadeIngressos: 10
  }
]

export const mockVisitors = [
  {
    isLoading: true,
    isMessage: false,
    isError: false,
    dia: "2025-03-12",
    visitasRecorrentes: 0,
    visitasUnicas: 0
  }
]

export const mockSectors = [
  {
    isLoading: true,
    isMessage: false,
    isError: false,
    id: 0,
    nome: 'SEM DADOS'
  }
]

export const mockHeatMapCoords = [
  {
    isMock: true,
    isLoading: true,
    isMessage: false,
    isError: false,
    lat: -15.75791,
    lng: -47.89453,
    weight: 2,
  }
];

// OBJECTS
export const mockDashboardData = {
  isLoading: true,
  isMessage: false,
  isError: false,
  quantidadeCortesias: '10',
  ticketMedio: 10,
  receitaTotal: 10,
  quantidadeIngressosVendidos: '99'
}

export const mockGoals = {
  isLoading: true,
  isMessage: false,
  isError: false,
  meta: 0,
  quantidadeVendas: 90,
  percentualMeta: 0,
  metas: [
    {
      dia: '2022-11-13T03:00:00.000',
      quantidadeIngressosVendidos: 0,
      meta: 10,
      percentualMeta: 0
    },
    {
      dia: '2022-11-14T03:00:00.000',
      quantidadeIngressosVendidos: 0,
      meta: 102,
      percentualMeta: 0
    }]
}

export const mockBlurData = {
  labels: ['28/12', '29/12', '30/12', '21/12', '09/11', '10/11', '11/11', '12/11', '13/11', '14/11'],
  chartData: {
    datasets:[
    {
      label: "Meta",
      data: [111, 111, 111, 324, 302, 38, 10, 212, 10, 102],
    },
    {
      label: "",
      data: [100, 30, 199, 20, 40, 11, 214, 50, 90, 30],
    },
  ]}
}

export const mockVisitorsInformation = [{
  isLoading: true,
  isMessage: false,
  isError: false,
  Masculino: "0",
  Feminino: "0",
  Undefined: "0",
}]

export const mockPaymentMethods = [
  {
    isLoading: true,
    isMessage: false,
    isError: false,
    categoria: 'PIX',
    label: 'PIX',
    quantidade: 0,
    valor: 0,
    percentual: 0,
  },
]

export const mockBuyerRecurrence = {
  isLoading: true,
  isMessage: false,
  isError: false,
  totalIdentificados: 0,
  comCortesia: { novos: 0, recorrentes: 0, percentualNovos: 0, percentualRecorrentes: 0 },
  semCortesia: { novos: 0, recorrentes: 0, percentualNovos: 0, percentualRecorrentes: 0 },
}

export const mockSalesCurve = {
  isLoading: true,
  isMessage: false,
  isError: false,
  inicio: null,
  fim: null,
  totalDias: 0,
  periodos: [],
  totais: { pedidos: 0, ingressos: 0, receita: 0 },
}

export const mockCampaignAttribution = {
  isLoading: true,
  isMessage: false,
  isError: false,
  canalVenda: 'todos',
  total: { receita: 0, ingressos: 0 },
  online: { receita: 0, ingressos: 0, pct: 0 },
  fisica: { receita: 0, ingressos: 0, pct: 0 },
  coberturaGA4Online: 0,
  coberturaCampanhaOnline: 0,
  lojaUrl: null,
  canais: [],
  campanhas: [],
}

export const mockEvent = {
  isLoading: true,
  isMessage: false,
  isError: false,
  data: '2023-01-02T21:00:00.000Z',
  endereco: 'Rua Francisco Corréa, 908 - Nova Esperança, Balneário Camboriú',
  latitude: '-27.0325902',
  local: 'Music Park BC',
  longitude: '-48.6031014',
  nome: 'VIVA SAMBA',
  uf: 'SC',
}

export const mockInterestMeter = {
  isLoading: true,
  isMessage: false,
  isError: false,
  percentualInteresse: null,
  quantidadeVendas: "0",
  quantidadeVisitas: 0
}
